import { render, staticRenderFns } from "./InvitationForm.vue?vue&type=template&id=1dc1a6fe&scoped=true&"
import script from "./InvitationForm.vue?vue&type=script&lang=js&"
export * from "./InvitationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc1a6fe",
  null
  
)

export default component.exports